import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiEndPointsFileManager } from '../common/apiUrls/api-end-points-fileManager';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileManagerService {
  private baseUrl: any;
  private baseUrlTrans: any;
  private baseUrlRole: any;
  private baseUrlsetting: any;
  private baseUrlCore: any;
  private baseURlOrg: any;
  private baseUrlClm: any;
  private baseUrlUser: any;
  
  private isProjectExtended:boolean;
  constructor(
    private _http: HttpClient,
    private apiAddress: ApiEndPointsFileManager,
    public env: EnvService,
    private constant: Constants
  ) {
    this.isProjectExtended=false;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.ManageContactsportNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.ManageContactsportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTrans =
        this.env.apiUrl + this.constant.ManageTranscationportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlRole = this.constant.RolePortNumber;
    else this.baseUrlRole = this.env.apiUrl + this.constant.RolePortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlsetting = this.constant.SettingsPortNumber;
    else this.baseUrlsetting = this.env.apiUrl + this.constant.SettingsPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlCore = this.constant.ManageCoreportNumber;
    else this.baseUrlCore = this.env.apiUrl + this.constant.ManageCoreportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
    else
      this.baseURlOrg = this.env.apiUrl + this.constant.ManageOrganizationPortNumber;
      if (this.env.apiUrl == undefined || this.env.apiUrl == '')
        this.baseUrlClm = this.constant.CustomizedGridComponentPortNumber;
      else
        this.baseUrlClm = this.env.apiUrl + this.constant.CustomizedGridComponentPortNumber;
        if(this.env.apiUrl==undefined  || this.env.apiUrl=='')
          this.baseUrlUser = this.constant.ManageUserPortNumber;
        else   
        this.baseUrlUser = this.env.apiUrl+this.constant.ManageUserPortNumber;
  }

  // private baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
  // private baseUrlTrans = this.constant.ManageTranscationportNumber;
  // //private baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  // private baseUrlRole = this.constant.RolePortNumber;
  //private baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber;


  getFoldersListForFML(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  
  addFolderinFileManager(reqModel): Observable<any> {
   const apiURL = this.baseUrlTrans + this.apiAddress.addFolderFileManager;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFilemanagerInboxItems(reqModel):Observable<any>{
   const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerInboxItems;
   return this._http.post(apiURL, reqModel).pipe();
  }

  FileManagerItemsWithHierarchy(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.FileManagerItemsWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
   }

   GetSharedWithMeFileManagerWithHierarchy(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManagerWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
   }

   GetFileManagerFileDetail(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFileManagerFileDetail;
    return this._http.post(apiURL, reqModel).pipe();
   }

   GetAllFileManagerTouches(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFileManagerTouches;
    return this._http.post(apiURL, reqModel).pipe();
   }

  addFilemanagerFile(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.addFileManagerFile;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadChunk(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.uploadChunk;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFileManagerItems(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFileManagerItems;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
  UpdateDocumentsDetailByDocumentId(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateDocumentsDetailsByDocumentId;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFromFolderSharedRole(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFromFolderSharedRole;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
  getAttachment(fileName,filePath): Observable<any> {
    const queryParam = '?fileName=' + filePath;
    const apiURL = this.baseUrlTrans + this.apiAddress.getAttachment + '' + queryParam;
    return this._http.get(apiURL).pipe();
  }

  GetAllFileFolderSharedRole(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFileFolderSharedRole;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ShareFileFolder (reqModel): Observable<any> {    
    const apiURL =  this.baseUrlTrans + this.apiAddress.ShareFileFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
  GetSharedWithMeFileManager (reqModel): Observable<any> {    
    const apiURL =  this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManager;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFileFolderSharedTo (reqModel): Observable<any> {    
    const apiURL =  this.baseUrlTrans + this.apiAddress.GetAllFileFolderSharedTo;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ModifyShareFileFolder (reqModel): Observable<any> {    
    const apiURL =  this.baseUrlTrans + this.apiAddress.ModifyShareFileFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
  DownloadDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DownloadDocument;    
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchFileManager(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DownloadDocument;   
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllFolderlist(dataModel) {
    const apiCallingURl = this.baseUrlsetting + this.apiAddress.getFoldersList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getCoreFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrlCore + this.apiAddress.getCoreFeildList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllFieldsCore(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseUrlCore + this.apiAddress.getAllFolderFields;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  searchTransCities(reqModel): Observable<any> {
    const apiURL = this.baseUrlCore + this.apiAddress.searchTransCities;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransZip(reqModel): Observable<any> {
    const apiURL = this.baseUrlCore + this.apiAddress.searchTransZip;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getStateList(countryId): Observable<any> {
    const apiCallingURl = this.baseURlOrg + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  getAllTagsList(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseUrlTrans + this.apiAddress.getAllTagList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getCoreUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getCoreUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
  getFileFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateDocumentTypeFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateDocumentTypeFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDocumentsbyType(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.getDocumentsbyType;
    return this._http.post(apiURL, reqModel).pipe();
   }

   updateCoreFieldColumnList(reqModel): Observable<any> {
    const apiURL = this.baseUrlClm + this.apiAddress.updateCoreFieldColumn;
    return this._http.post(apiURL, reqModel).pipe();
  }

  advancedSearch(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.advancedSearch;
    return this._http.post(apiURL, reqModel).pipe();
   }

   GetUserList(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.GetUserList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFileAuthors(dataModel) {   
    const apiCallingURl = this.baseUrlTrans + this.apiAddress.getFileAuthors;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  
  getFileTypes(dataModel) {   
    const apiCallingURl = this.baseUrlTrans + this.apiAddress.getFileTypes;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  AddVectorFileID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddVectorFileID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ExtractTextForFileManagerListProcessIcon(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ExtractTextForFileManagerListProcessIcon;
    return this._http.post(apiURL, reqModel).pipe();
  }

 processDocument(url: string, userId: string, officeId: string, organizationId: string,pdftext:string=""): Observable<any> {
     const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/process_document_url';
      //  const params = new HttpParams()
      //    .set('url', url)
      //    .set('UserID', userId)
      //    .set('OfficeID', officeId)
      //    .set('OrganizationID', organizationId)
      //    .set('pdftext', pdftext);
      const body = {
        url: url,
        UserID: userId,
        OfficeID: officeId,
        OrganizationID: organizationId,
        pdftext: pdftext
    };
     // return this._http.post(apiURL, null, { params, observe: 'response' }).pipe(
      return this._http.post(apiURL, body, { observe: 'response' }).pipe(
        map(response => {
          if (response.status === 200) {
            return { success: true, message: response.body['message'] };
          } else {
            return { success: false, message: response.body['message'] };
          }
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError({ success: false, message: error.message });
        })
      );
    }
  
    GetDocumentCategoriesPCC(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetDocumentCategoriesPCC;
      return this._http.post(apiURL, reqModel).pipe();
    }

    attachAIAutomationTemplate(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.attachAIAutomationTemplate;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getAIAutomationTemplates(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getAIAutomationTemplates;
      return this._http.post(apiURL, reqModel).pipe();
    }

    aIAutomationRunManuallyForFile(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.aIAutomationRunManuallyForFile;
      return this._http.post(apiURL, reqModel).pipe();
    }

    reRunAutomationForAITool(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.reRunAutomationForAITool;
      return this._http.post(apiURL, reqModel).pipe();
    }


    mergePdfFiles(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.mergePdfFiles;
      return this._http.post(apiURL, reqModel).pipe();
    }

    FetchDocAsync(reqModel: any): Promise<Blob> {
      const endpoint = this.baseUrlTrans + this.apiAddress.FetchDocAsync;
      return this._http.post(endpoint,reqModel, { responseType: 'blob' }).toPromise();
    }

    getMergedFileHistory(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getMergedFileHistory;
      return this._http.post(apiURL, reqModel).pipe();
    }

}
